import { ApiProjectSettingKey, ApiProjectType } from "@incendium/api";

export function projectHasType(
  projectTypeValue: string | undefined,
  type: ApiProjectType,
): boolean {
  if (!projectTypeValue) return false;
  return projectTypeValue
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)
    .includes(`${type}`);
}

export function projectHasTypeFromSettings(
  settings: { key?: ApiProjectSettingKey; value?: string }[] | undefined,
  type: ApiProjectType,
): boolean {
  const value = settings?.find((s) => s.key === ApiProjectSettingKey.PROJECT_TYPE)
    ?.value;
  return projectHasType(value, type);
}
